import * as React from 'react';
import { dig, getPureTime, getTimeParts, toTimeString } from './common.js';
var PickerButton = function (_a) {
    var onClick = _a.onClick, type = _a.type;
    return (React.createElement("div", { className: "mdpch-button" },
        React.createElement("div", { className: "mdpchb-inner", onClick: onClick },
            React.createElement("span", { className: "mdpchbi-".concat(type) }))));
};
export var PickerPopup = function (_a) {
    var value = _a.value, min = _a.min, max = _a.max, dispatch = _a.dispatch;
    var isBetweenMinMax = function (time) { return time <= max && time >= min; };
    var change = function (time) {
        if (isBetweenMinMax(time)) {
            dispatch({
                valid: true,
                time: time,
                showPicker: true,
                input: toTimeString(time),
            });
        }
    };
    var _b = getTimeParts(value), hours = _b[0], minutes = _b[1], seconds = _b[2], milliseconds = _b[3];
    var setHours = function (delta) {
        change(getPureTime([hours + delta, minutes, seconds, milliseconds]));
    };
    var setMinutes = function (delta) {
        change(getPureTime([hours, minutes + delta, seconds, milliseconds]));
    };
    var setSeconds = function (delta) {
        change(getPureTime([hours, minutes, seconds + delta, milliseconds]));
    };
    var setMilliseconds = function (delta) {
        change(getPureTime([hours, minutes, seconds, milliseconds + delta]));
    };
    return (React.createElement("div", { className: "mdp-container mdp-time" },
        React.createElement("div", { className: "mdp-time-column" },
            React.createElement(PickerButton, { type: "top-arrow", onClick: function () { return setHours(1); } }),
            React.createElement("strong", null, dig(hours, 2)),
            React.createElement(PickerButton, { type: "bottom-arrow", onClick: function () { return setHours(-1); } })),
        React.createElement("div", { className: "mdp-time-column mdp-time-column-divider" }, ":"),
        React.createElement("div", { className: "mdp-time-column" },
            React.createElement(PickerButton, { type: "top-arrow", onClick: function () { return setMinutes(1); } }),
            React.createElement("strong", null, dig(minutes, 2)),
            React.createElement(PickerButton, { type: "bottom-arrow", onClick: function () { return setMinutes(-1); } })),
        React.createElement("div", { className: "mdp-time-column mdp-time-column-divider" }, ":"),
        React.createElement("div", { className: "mdp-time-column" },
            React.createElement(PickerButton, { type: "top-arrow", onClick: function () { return setSeconds(1); } }),
            React.createElement("strong", null, dig(seconds, 2)),
            React.createElement(PickerButton, { type: "bottom-arrow", onClick: function () { return setSeconds(-1); } })),
        React.createElement("div", { className: "mdp-time-column mdp-time-column-divider" }, "."),
        React.createElement("div", { className: "mdp-time-column" },
            React.createElement(PickerButton, { type: "top-arrow", onClick: function () { return setMilliseconds(1); } }),
            React.createElement("strong", null, dig(milliseconds, 3)),
            React.createElement(PickerButton, { type: "bottom-arrow", onClick: function () { return setMilliseconds(-1); } }))));
};
//# sourceMappingURL=PickerPopup.js.map